{
	"optionsBoardWidgetActions": {
		"settingsColumns": "Column settings",
		"columns": {
			"strike": "Strike",
			"bid": "Bid",
			"ask": "Ask",
			"last": "Last Price",
			"change": "Today %",
			"breakeven": "Breakeven",
			"volatility": "Implied Vol.",
			"interest": "Open Int.",
			"delta": "Delta",
			"gamma": "Gamma",
			"theta": "Theta",
			"vega": "Vega"
		}
	}
}
